<script type="text/ecmascript-6">
import AxAttributesBase from './AxAttributesBase';

export default {
    extends: AxAttributesBase,
    props: {
        variant: Object,
    },
    methods: {},
    computed: {
        variantSize() {
            return this.variant.size;
        },
        pricesRegular() {
            return this.variant.regularPricesPerClientname;
        },
        pricesOffer() {
            return this.variant.offerPricesPerClientname;
        },
        campaignPrices() {
            return this.variant.validCampaignPricesPerPriceGroup;
        },
        stock() {
            return this.variant.stock;
        },
    }
}
</script>

<template>
    <div :id="'axindex-'+variantSize.articleNr" :ref="'axindex-'+variantSize.articleNr">
        <h4>Größenvariante (<span v-text="variantSize.articleNr"></span>)</h4>
        <hr>
        <div class="row p-w-xl">
            <div class="col-md-6">
                <div class="col-md-6">
                    <h5 class="m-b-xs">eShop</h5>
                    <p class="text-muted m-b-md">
                        <span class="label"
                              :class="variantSize.isActiveInShop ? 'label-primary' : 'label-warning'"
                              v-text="variantSize.isActiveInShop ? 'aktiv' : 'inaktiv'"
                        ></span>
                    </p>
                    <h5 class="m-b-xs">Betrag</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.amount"></p>
                    <h5 class="m-b-xs">Breite</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.width"></p>
                    <h5 class="m-b-xs">Bruttobreite</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.gross_width"></p>
                    <h5 class="m-b-xs">Bruttogewicht</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.gross_weight"></p>
                    <h5 class="m-b-xs">Bruttohöhe</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.gross_height"></p>
                    <h5 class="m-b-xs">Bruttotiefe</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.gross_depth"></p>
                    <h5 class="m-b-xs">CodeArtikelnummer</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.codeArticleNr"></p>
                    <h5 class="m-b-xs">Energieeffizienzklasse</h5>
                    <p class="text-muted m-b-md">-</p>
                    <h5 class="m-b-xs">Größe</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.size_id"></p>
                    <h5 class="m-b-xs">GTIN</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.gtin"></p>
                    <h5 class="m-b-xs">Höhe</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.height"></p>
                </div>
                <div class="col-md-6">
                    <h5 class="m-b-xs">Nettogewicht</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.net_weight"></p>
                    <h5 class="m-b-xs">OfferPrice</h5>
                    <ul class="text-muted m-b-md">
                        <li v-for="(price, clientName) in pricesOffer" v-if="pricesOffer && price > 0">
                            <span v-text="clientName"></span>: <span v-text="price"></span>
                        </li>
                    </ul>
                    <h5 class="m-b-xs">Packstücke</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.packages"></p>
                    <h5 class="m-b-xs">RegularPrice</h5>
                    <ul class="text-muted m-b-md">
                        <li v-for="(price, clientName) in pricesRegular">
                            <span v-text="clientName"></span>: <span v-text="price"></span>
                        </li>
                    </ul>
                    <h5 class="m-b-xs">Durchmesser</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.diameter"></p>
                    <h5 class="m-b-xs">Tiefe</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.depth"></p>
                    <h5 class="m-b-xs">Verpackungsgewicht</h5>
                    <p class="text-muted m-b-md" v-text="variantSize.packaging_weight"></p>
                    <h5 class="m-b-xs">Warencode</h5>
                    <p class="text-muted m-b-md"
                       v-text="variantSize.commodity_code ? variantSize.commodity_code : '-'"></p>
                    <h5 class="m-b-xs">Warencode Abweichend</h5>
                    <p class="text-muted m-b-md"
                       v-text="variantSize.commodity_code_alternate ? variantSize.commodity_code_alternate : '-'"></p>
                    <h5 class="m-b-xs">Bestand</h5>
                    <p class="text-muted m-b-md" v-text="stock && stock.stock ? stock.stock : '-'"></p>
                    <h5 class="m-b-xs">bestellter Bestand</h5>
                    <p class="text-muted m-b-md"
                       v-text="stock && stock.order_stock ? stock.order_stock : '-'"></p>
                    <h5 class="m-b-xs">virtueller Bestand</h5>
                    <p class="text-muted m-b-md"
                       v-text="stock && stock.virtual_stock ? stock.virtual_stock : '-'"></p>
                    <h5 class="m-b-xs">Lieferzeit</h5>
                    <p class="text-muted m-b-md"
                       v-text="stock && stock.delivery_time ? stock.delivery_time : '-'"></p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="col-md-6">
                    <h4>Katalogpreise</h4>
                    <div v-for="campaignPrice in campaignPrices">
                        <h5 class="m-b-xs">{{ campaignPrice.price_group }}</h5>
                        <p class="text-muted m-b-md">{{ campaignPrice.price }} {{ campaignPrice.currency }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
